import { FC } from 'react';
import { useImageUrl, UseImageUrlBaseProps } from '../../hooks/useImageUrl';

export interface TeamLogoProps extends Partial<UseImageUrlBaseProps> {
  className?: string;
  team: string;
  fallbackTeam?: string;
}

export const TeamLogo: FC<TeamLogoProps> = ({
  className,
  team,
  fallbackTeam = '',
  ext = 'png',
  hostname = 'https://engagecraftfantasydev.blob.core.windows.net',
  pathname = 'teams/logos',
}) => {
  const { url, value, onError } = useImageUrl({
    value: team,
    fallbackValue: fallbackTeam,
    hostname,
    pathname,
    ext,
  });

  return (
    <picture>
      <img className={className} src={url.toString()} alt={value} onError={onError} />
    </picture>
  );
};
